export default __webpack_public_path__ + "static/media/02Ndip60s.684a0a15.mp3";